import { render, staticRenderFns } from "./InvolvedSelect.vue?vue&type=template&id=45f9fcfb"
import script from "./InvolvedSelect.vue?vue&type=script&lang=js"
export * from "./InvolvedSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports